module.exports = __webpack_public_path__ + "img/deposit-gold.588f8806.svg";